import { render, staticRenderFns } from "./ColorSelectBox.vue?vue&type=template&id=cece2338&scoped=true"
import script from "./ColorSelectBox.vue?vue&type=script&lang=js"
export * from "./ColorSelectBox.vue?vue&type=script&lang=js"
import style0 from "./ColorSelectBox.vue?vue&type=style&index=0&id=cece2338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cece2338",
  null
  
)

export default component.exports